"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.AcPageDataListToolbar = void 0;
var react_1 = __importDefault(require("react"));
var ac_ui_1 = require("@aperza/ac-ui");
var AcPageDataListContext_1 = require("./AcPageDataListContext");
var AcPageDataListToolbar = function (_a) {
    var pageSizes = _a.pageSizes, toolbar = _a.toolbar, filterBar = _a.filterBar;
    var acPageDataListContext = AcPageDataListContext_1.useAcPageDataListContext();
    var page = acPageDataListContext.page, pageSize = acPageDataListContext.pageSize, getTotalElements = acPageDataListContext.getTotalElements, updatePageSize = acPageDataListContext.updatePageSize;
    return (react_1.default.createElement("div", { className: "d-flex flex-row mb-3 mt-3 align-items-center" },
        react_1.default.createElement(ac_ui_1.AcPaginationInfo, { page: page, size: pageSize, totalElements: getTotalElements() }),
        react_1.default.createElement("div", { className: "ml-auto d-flex flex-row" },
            toolbar,
            pageSize > 0 && (react_1.default.createElement(ac_ui_1.AcTablePageSizeDropdown, { pageSize: pageSize, pageSizes: pageSizes, updatePageSize: updatePageSize }))),
        filterBar && react_1.default.createElement("div", { className: "ml-3" }, filterBar)));
};
exports.AcPageDataListToolbar = AcPageDataListToolbar;
exports.AcPageDataListToolbar.displayName = 'AcPageDataListToolbar';
//# sourceMappingURL=AcPageDataListToolbar.js.map